import React, { Component, useState, useEffect } from "react";
import DatePicker, {
  Calendar,
  CalendarPicker,
} from "@/components/ReactRangePicker";

import { RangePickerInput, DatePickerInput } from "../input";

// import './index.css';

export default (props) => {
  const {
    onChange = () => {},
    disabled,
    placeholder,
    allowClear,
    showTime,
    style = {},
    className = "",
    inputReadOnly = true,
    size,
    value: valueProp,
  } = props;
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState();

  useEffect(() => {
    setValue(value);
  }, [valueProp]);

  return (
    <>
      <div
        style={style}
        onClick={(event) => {
          event.preventDefault(); // 阻止表单提交的默认行为
          event.stopPropagation(); // 阻止事件冒泡
          if (disabled) {
            return;
          }
          setOpen(true);
        }}
      >
        <DatePickerInput
          size={size}
          style={style}
          className={className}
          inputReadOnly={inputReadOnly}
          placeholder={placeholder}
          value={value}
          defaultValue={value}
          disabled={disabled}
          allowClear={allowClear}
          showTime={showTime}
          onChange={(v) => {
            if (v) {
              setValue(v);
              onChange(v);
            } else {
              setValue(undefined);
              onChange(undefined);
            }
          }}
        />
      </div>

      <CalendarPicker
        type={"date"}
        value={value}
        visible={open}
        showTime={showTime}
        onChange={(date) => {
          setOpen(false);
          setValue(date);
          onChange(date);
        }}
      />
    </>
  );
};
